import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthSessionValid, isPanelAdmin } from "../utils/authSession";

function ProtectedRoute() {
  const isLoggedIn = isAuthSessionValid() && isPanelAdmin();
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" replace />;
}

export default ProtectedRoute;